import { ajvResolver } from '@hookform/resolvers/ajv'
import { Link } from '@mui/material'
import { Form } from 'components/form'
import { useAlert } from 'contexts/alert'
import { useAuth } from 'contexts/auth'
import { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import CertificateSchema, { ICertificateFormData } from 'schema/authentication/certificate'
import api from 'services/api'

const Certificate = () => {
  const [files, setFiles] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isDisabled, setIsDisabled] = useState<boolean>(true)

  const { user, updateUserData } = useAuth()
  const { closeAlert, openAlert } = useAlert()

  const certificateAlreadyUploaded =
    user && user.skipUpload ? true : user && user.organization?.uploadedCertificate ? true : false

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm<ICertificateFormData>({
    resolver: ajvResolver(CertificateSchema),
  })

  const handleChange = (formField: any) => closeAlert()

  const onSubmit = useCallback(
    async (data: ICertificateFormData) => {
      try {
        const formData = new FormData()
        formData.append('cnpj', user!.organization?.cnpj as string)
        formData.append('certificate', files[0])
        formData.append('certificatePassword', data.password)
        formData.append('acceptance', `${data.acceptance}`)

        setIsLoading(true)

        await api.patch('/users/certificate', formData)

        setIsLoading(false)
        openAlert('Certificado enviado com sucesso!', 'success')
        await updateUserData()
        window.location.reload()
      } catch (err) {
        setIsLoading(false)
        openAlert('Erro ao enviar o certificado!', 'error')
      }
    },
    [files]
  )

  return (
    <Form.Root onHandleSubmit={handleSubmit(onSubmit)}>
      <Form.Info
        title={`${certificateAlreadyUploaded ? 'Atualizar' : 'Enviar'} Certificado`}
        subTitle='Envio ou atualização do certificado digital'
      />

      <Form.Body>
        <Form.Input
          type='file'
          label='Certificado Digital'
          placeholder='Selecione o certificado digital'
          helperText='Arquivos do tipo .P12 e .PFX'
          name='certificate'
          error={!!errors.certificate}
          errorMessage={errors?.certificate?.message}
          disabled={true}
          maxLength={20}
          sizing={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
          rules={{ onChange: (e) => handleChange(e) }}
          register={register}
          fileAccept='.p12, .pfx'
          fileState={setFiles}
          onSetValue={setValue}
        />

        <Form.Input
          label='Senha do Certificado Digital'
          placeholder='Digite a Senha do Certificado'
          type='password'
          name='password'
          error={!!errors.password}
          errorMessage={errors?.password?.message}
          disabled={isLoading}
          maxLength={20}
          sizing={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
          rules={{ onChange: (e) => handleChange(e) }}
          register={register}
        />

        <Form.CheckBox
          label={
            <span>
              Eu autorizo a Conducco a coletar dados em meu nome na base do eSocial. Li e concordo com os{' '}
              <Link
                download
                href='/documents/Termose_Condicoes_Conducco-10_01_2024.pdf'
              >
                Termos de Uso
              </Link>{' '}
              e a{' '}
              <Link
                download
                href='/documents/Politica_Privacidade.pdf'
              >
                Política de Privacidade
              </Link>{' '}
              da Conducco
            </span>
          }
          sizing={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          name='acceptance'
          control={control}
          onChange={(e) => setIsDisabled(!e.target.checked)}
        />
      </Form.Body>

      <Form.Divisor />

      <Form.Footer>
        <Form.Button
          label={certificateAlreadyUploaded ? 'ATUALIZAR' : 'ENVIAR'}
          type='submit'
          variant='contained'
          isLoading={isLoading}
          isDisabled={isDisabled}
        />
        <Form.Button
          label='CANCELAR'
          type='cancel'
          variant='text'
          isLoading={isLoading}
        />
      </Form.Footer>
    </Form.Root>
  )
}

export default Certificate
